module.exports = __webpack_public_path__ + "static/media/detailIOT.a4abe5ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fi/detailIOT.png
// module id = 86
// module chunks = 0